import { createReducer, on } from '@ngrx/store';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { DATA_IN_LEGEND_DEFAULT } from 'ChartApp/ts/features/fundamental-chart/constants';
import { FundChartOptionValue } from 'ChartApp/ts/enums/fund-chart-common.enum';
import { setDataInLegendOption } from './chart-options.actions';
import { setFundChart } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.actions';
export const dataInLegend = createReducer(DATA_IN_LEGEND_DEFAULT, on(setChartData, (state, { chartData }) => chartData.params.dataInLegend), on(setDataInLegendOption, (state, action) => {
    return action.dataInLegend;
}), on(setFundChart, (state, action) => {
    return action.fundChart[FundChartOptionValue.DATA_IN_LEGEND];
}));
